import { render, staticRenderFns } from "./BadgeActionPoint.vue?vue&type=template&id=02966615&"
import script from "./BadgeActionPoint.vue?vue&type=script&lang=js&"
export * from "./BadgeActionPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports